import { isAllowedBookingStatus } from "../../../../common/utils/helpers/isAllowedBookingStatus";
import { BookingStatusMessage, hasBookingStatusMessage } from "./hasBookingStatusMessage";

type ShouldShowLegacyErrorHeadingParams = {
  statusMessage?: BookingStatusMessage | null;
  apiError: boolean;
  bookingStatus?: string;
};

// Fallback when BE did not send booking_status_message (apiError, polling timeout, disallowed status).
// Prefer API title/text whenever present — including for booking_status === "error".
export const shouldShowLegacyErrorHeading = ({
  statusMessage,
  apiError,
  bookingStatus
}: ShouldShowLegacyErrorHeadingParams): boolean =>
  !hasBookingStatusMessage(statusMessage) &&
  (apiError || bookingStatus === "error" || !isAllowedBookingStatus(bookingStatus as string));
